<template>
  <app-modal
    v-model="isDialogOpened"
    size="xs"
    :cancel-text="$t('common.cancel')"
    :ok-text="$t('common.continue')"
    @cancel="closeDialog"
    @ok="onConfirm"
  >
    <template #title>
      {{ $t('project.documents.dialogs.RedactStorageWarningDialog.title') }}
    </template>

    <template #body>
      <p class="text--small">{{ $t('project.documents.dialogs.RedactStorageWarningDialog.text') }}</p>
      <v-checkbox
        v-model="hideDialog"
        class="mt-3"
        :label="$t('project.documents.dialogs.RedactStorageWarningDialog.checkboxLabel')"
        hide-details
        density="compact"
      />
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { dialogMixin } from '@/mixins/dialogMixin'

export default defineComponent({
  name: 'RedactStorageWarningDialog',
  mixins: [dialogMixin],
  emits: ['confirm'],
  data () {
    return {
      hideDialog: false,
    }
  },
  methods: {
    onConfirm () {
      this.$emit('confirm', this.hideDialog)
      this.closeDialog()
    },
  },
})
</script>
